import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../config/design/TableIcons";
import {Link, withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import {TableCount, TablePage} from "../../../../config/Permissions";
import Button from "@material-ui/core/Button/Button";
import AddBox from "@material-ui/icons/AddBox";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import AppCardLoaderTable from "../../../components/Skeletons/AppCardLoaderTable";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert/Alert";
import {convertSeconds} from "../../../../config/values";
import {DesktopWindowsRounded, SmartphoneRounded, TabletRounded} from "@material-ui/icons";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";

class Visitors extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            { title: Translate.unique_id, field: 'unique_id',filterPlaceholder: Translate.search,sorting:false,},
            {
                title: Translate.ip,
                field: 'ip',
                filterPlaceholder: Translate.search,
                sorting:false,
                render: rowData =>
                    <a style={{color:"#e4bf3f"}} href={`https://whatismyipaddress.com/ip/${rowData.ip}`} target="_blank" className="date_in_table">
                        {rowData.ip}
                    </a>
            },
            { title: Translate.platform, field: 'platform',filterPlaceholder: Translate.search,sorting:false,},
            {
                title: Translate.device,
                field: 'width',
                filterPlaceholder: Translate.search,
                sorting:false,
                render: rowData =>
                    <Tooltip title={rowData.width+"px"} arrow>
                    {
                        rowData.width < 500 ?
                            <SmartphoneRounded/>
                            :
                            rowData.width < 1000 ?
                            <TabletRounded/>
                            :
                                <DesktopWindowsRounded/>
                    }
                    </Tooltip>
            },
            { title: Translate.mobile, field: 'mobile',filterPlaceholder: Translate.search,sorting:false,},

            { title: Translate.total_visits, field: 'visits_count',filterPlaceholder: Translate.search,sorting:false,},
            {
                title: Translate.lastVisit,
                editable: 'never',
                sorting:false,
                hidden: this.props.width === "xs",
                field: 'updated_at',
                render: rowData =>
                    <Typography className="date_in_table">
                        {`${moment(rowData.updated_at).locale('fa').fromNow()}`}
                        <br/>
                        {`${moment(rowData.updated_at).locale('fa').format( 'HH:mm , YYYY/M/D')}`}
                    </Typography>
            },
        ],
        data: [],
        loading:false,
        ChangeLoader:false
    };
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }

    render(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl">
                            <MaterialTable
                                tableRef={this.tableRef}
                                icons={tableIcons}
                                title={" "}
                                localization={DataTableLocalization}
                                columns={this.state.columns}
                                data={query =>
                                    new Promise((resolve, reject) => {
                                        axios.get(`${defaultVariabls.url}/analytics/visitors-overview?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, config)
                                            .then(response => {
                                                let data = [];
                                                console.log(response.data.data)
                                                // eslint-disable-next-line
                                                response.data.data.map((row) => {
                                                    data.push({
                                                        unique_id: row.unique_id,
                                                        ip: row.ip_address,
                                                        mobile: row.mobile,
                                                        visits: row.visits,
                                                        visits_count: row.visits.length,
                                                        width: row.screen_width,
                                                        platform: row.platform,
                                                        id: row.id,
                                                        updated_at:row.updated_at
                                                    })
                                                });
                                                resolve({
                                                    data: data,
                                                    page: response.data.current_page - 1,
                                                    totalCount: response.data.total,
                                                })
                                            }).catch(error => {
                                            console.log(error.response)
                                        })
                                    })
                                }
                                options={{
                                    pageSize: TablePage,
                                    pageSizeOptions: TableCount,
                                    draggable:false,
                                }}
                                detailPanel={rowData => {
                                    return (
                                        <Grid container spacing={2}>
                                            {
                                                rowData.visits.map((visit,index) => (
                                                    <Grid item xs={12} key={index}>
                                                        <Alert
                                                            icon={false}
                                                            severity="info"
                                                            action={
                                                                <span dir="ltr">
                                                                    {convertSeconds(moment.duration(moment(visit.updated_at).diff(moment(visit.created_at))).asSeconds())}
                                                                </span>
                                                            }

                                                        >
                                                            <span dir="ltr">{visit.url}</span>
                                                            {
                                                               !!visit.campaign &&
                                                                <Typography style={{fontSize:10,color:"#555"}} dir="ltr">
                                                                    Campaign: <strong>{visit.campaign}</strong> | Source: <strong>{visit.source}</strong> | Medium: <strong>{visit.medium}</strong> | Term: <strong>{visit.term}</strong>
                                                                </Typography>
                                                            }
                                                        </Alert>
                                                    </Grid>
                                                ))
                                            }
                                        </Grid>
                                    )
                                }}
                            />
                        </Container>
                }
            </>

        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Visitors)))));